import React from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { Layout, Menu } from 'antd'
import { Link } from 'react-router-dom'

import dashboardIcon from '../../assets/logo/dashboard.svg'
import dashboardIconSelected from '../../assets/logo/dashboard_selected.svg'

import xchangeIcon from '../../assets/logo/xchange.svg'
import xchangeIconSelected from '../../assets/logo/xchange_selected.svg'

import syncIcon from '../../assets/logo/sync-icon.png'
import syncIconSelected from '../../assets/logo/sync-icon-selected.png'


import hybridIcon from '../../assets/logo/hybrid.svg'
import hybridIconSelected from '../../assets/logo/hybrid_selected.svg'

import usersIcon from '../../assets/logo/add-user.png'
import usersIconSelected from '../../assets/logo/add-user-blue.png'

import hybrikIcon from '../../assets/logo/hybrik 2.png'
import hybrikIconSelected from '../../assets/logo/hybrik-selected 2.png'

import analyticsIcon from '../../assets/logo/analytics.svg'
import analyticsIconSelected from '../../assets/logo/analytics_selected.svg'

import financeIcon from '../../assets/logo/finance.svg'
import financeIconSelected from '../../assets/logo/finance_selected.svg'

import searchIcon from '../../assets/logo/litemam.svg'
import searchIconSelected from '../../assets/logo/litemam_selected.svg'

/*import s3Icon                from '../../assets/logo/fc.png'
import s3IconSelected        from '../../assets/logo/fc-selected.png'

import hybridIcon             from '../../assets/logo/cloud.png'
import hybridIconSelected     from '../../assets/logo/cloud-selected.png'

import usersIcon             from '../../assets/logo/users.png'
import usersIconSelected     from '../../assets/logo/users-selected.png'*/

/*import hybridIcon            from '../../assets/logo/hybrid.png'
import hybridIconSelected    from '../../assets/logo/hybrid-selected.JPG'*/

/*import xchangeIcon           from '../../assets/logo/xchange.png'
import xchangeIconSelected   from '../../assets/logo/xchange-selected.png'*/

import './styles.scss'

const { Sider } = Layout

class Sidebar extends React.Component {
  constructor(props) {
    super(props)

    const { user = {} } = this.props
    const show_users = user && user.role && user.role.title !== 'User'
    let {
      has_s3_native,
      has_fc,
      has_encoding,
      has_hybrik,
      has_analytics,
      has_desktop_app,
      has_wasabi,
      has_finance,
    } = user ? user.acl || {} : {}
    const { referrer_id, organization: { is_cbs } = {} } = user || {}

    this.state = {
      activeKey: '1',
      collapsed: true,
      mode: 'inline',
      slack_on_sidebar: false,
      menus: [
        {
          path: '/dashboard',
          name: 'Dashboard',
          icon: dashboardIcon,
          selected_icon: dashboardIconSelected,
          visible: true,
        },
        {
          path: '/',
          name: 'Hybrid',
          icon: hybridIcon,
          selected_icon: hybridIconSelected,
          visible: true,
        },
        {
          path: '/c2c',
          name: 'Transfers',
          icon: xchangeIcon,
          selected_icon: xchangeIconSelected,
          visible: true,
        },
        {
          path: '/Sync',
          name: 'Sync',
          icon: syncIcon,
          selected_icon: syncIconSelected,
          visible: true,
        },
        // {
        //   path: '/search',
        //   name: 'Search',
        //   icon: searchIcon,
        //   selected_icon: searchIconSelected,
        //   visible: true,
        //   /* visible: is_cbs */
        // },
        // {
        //   path: '/analytics',
        //   name: 'Analytics',
        //   icon: analyticsIcon,
        //   selected_icon: analyticsIconSelected,
        //   visible: true,
        // },
        // {
        //   path: '/finance',
        //   name: 'Finance',
        //   icon: financeIcon,
        //   selected_icon: financeIconSelected,
        //   /* visible: is_cbs || has_finance */
        //   visible: true,
        // },
        /*{
          path: "/hybrik",
          name: "Hybrik",
          icon: hybrikIcon,
          selected_icon: hybrikIconSelected,
          /!* visible : is_cbs, *!/
          visible: true,
          className: "hybrik"
        },*/
        {
          path: '/users/invite',
          name: 'Users',
          icon: usersIcon,
          selected_icon: usersIconSelected,
          visible: show_users,
        },

        /*{
                  path : '/analytics',
                  name : 'Analytics',
                  icon : analyticsIcon,
                  selected_icon : analyticsIconSelected,
                  visible : has_analytics
                },
                {
                  path : '/transfers',
                  name : 'Transfer Accelerator',
                  icon : fcIcon,
                  selected_icon : fcIconSelected,
                  visible : has_fc
                },*/

        /*{
                  path : '/s3Direct',
                  name : 'S3 Direct',
                  icon : s3Icon,
                  selected_icon : s3IconSelected,
                  visible : referrer_id === 1 && has_s3_native
                },*/
        /* {
                   path : '/wasabi',
                   name : 'Wasabi',
                   icon : wasabiIcon,
                   selected_icon : wasabiIconSelected,
                   visible : referrer_id === 1 && has_wasabi
                 },*/
        /* {
                  path : '/encoding',
                  name : 'Encoding',
                  icon : encodingIcon,
                  selected_icon : encodingIconSelected,
                  visible : has_encoding
                },
                {
                  path : '/hybrik',
                  name : 'Hybrik',
                  icon : hybrikIcon,
                  selected_icon : hybrikIconSelected,
                  visible : has_encoding,
                  className:'hybrik'
                },
                {
                  path : '/apps',
                  name : 'Apps',
                  icon : appsIcon,
                  selected_icon : appsIconSelected,
                  visible : has_desktop_app
                }, */

        /*{
                  path : '/slack',
                  name : 'Slack',
                  icon : slackIcon,
                  selected_icon : slackIconSelected,
                  visible : false //(props.auth.user || {}).slack_on_sidebar
                }*/
      ],
    }
  }

  on_menu_click = item => this.setState({ activeKey: item.key })

  render() {
    const {
      location: { pathname },
    } = this.props
    let { menus } = this.state
    return (
      <Sider
        collapsed={true}
        onCollapse={this.props.onToggle}
        trigger={null}
        breakpoint="lg"
        className="sider_comp"
      >
        <Menu
          mode={this.state.mode}
          theme="Light"
          //selectedKeys={[activeKey]}
          selectedKeys={[pathname]}
          onClick={this.on_menu_click}
        >
          {menus.map(
            menu =>
              menu.visible && [
                //<Menu.Divider key={menu.name}/>,
                <Menu.Item key={menu.path}>
                  <Link to={menu.path}>
                    <i
                      className="anticon anticon-undefined"
                      style={{ fontSize: 20 }}
                    >
                      {pathname === menu.path ? (
                        <img
                          src={menu.selected_icon}
                          className={'sider-icon ' + menu.className}
                        />
                      ) : (
                        <img
                          src={menu.icon}
                          className={'sider-icon ' + menu.className}
                        />
                      )}
                    </i>
                    <span>{menu.name}</span>
                  </Link>
                </Menu.Item>,
              ]
          )}
        </Menu>
      </Sider>
    )
  }
}

function mapStateToProps(state, { match, history }) {
  let { auth } = state
  return { user: auth.user, auth }
}

function mapDispatchToProps(dispatch) {
  return {}
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Sidebar)
)
